import React, { Component } from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { authorize } from "../../utils/AuthService";
import useSession from "../../hooks/Auth/useSession";
import useGetCustomer from "../../hooks/CustomerProfile/useGetCustomer";

const AuthorizeComponent = (props) => {
  const { user, customerId, accessToken } = useSession();
  const { data: customer } = useGetCustomer(customerId);

  if (!customer?.customerId) {
    return <div>Loading...</div>;
  }

  const authorizeRoles = () => {
    if (!props.roles || props.roles.length === 0) {
      return true;
    }

    return accessToken && authorize(user, ...props.roles);
  };

  const customAuthorization =
    typeof props.authorize === "function"
      ? props.authorize({ customer })
      : true;

  if (authorizeRoles() && customAuthorization) {
    return React.createElement(props.component, props.componentProps);
  } else {
    setTimeout(() => {
      window.location.href = "/";
    }, 3000);
    return (
      <div className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-64 tw-text-2xl tw-font-light">
        <p>Unauthorized.</p>
        <p className="tw-text-gray-500 tw-text-lg">
          Redirecting to the dashboard in 3 seconds
        </p>
      </div>
    );
  }
};

export default class PrivateRoute extends Component {
  render() {
    return (
      <Route
        exact={this.props.exact}
        path={this.props.path}
        render={(props) =>
          this.props.authenticated ? (
            <AuthorizeComponent
              component={this.props.component}
              componentProps={props}
              roles={this.props.authorizeRoles}
              user={this.props.userHelper}
              authorize={this.props.authorize}
            />
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location },
              }}
            />
          )
        }
      />
    );
  }
}

const { object, bool, string, func } = PropTypes;

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([func.isRequired, object.isRequired]),
  exact: bool,
  path: string.isRequired,
  authenticated: bool.isRequired,
  location: object,
};
